import type { DbTag } from '@domain/schemas/tag.schema';
import type { EntityData } from '@domain/types/entity';
import ItemTags from '@pages/User/components/ItemTags';
import { isNonNullish } from '@root/helpers';
import type { ColumnHelper } from '@tanstack/react-table';

export const tagsAccessor = <T extends { tags?: string[] }>(columnHelper: ColumnHelper<T>, tags: DbTag[]) =>
  columnHelper.accessor(
    (submission) =>
      (submission.tags ?? [])
        .map((tagId) => {
          return tags?.find((tag) => tag.id === tagId)?.label;
        })
        .join(''),
    {
      id: 'tags',
      header: 'Tags',
      enableSorting: false,
      size: 164,
      minSize: 164,
      maxSize: 164,
      cell: (info) => {
        return <ItemTags item={info.row.original as unknown as EntityData} tags={tags} />;
      },
      filterFn: (row, _, filteredTagLabels) => {
        if (!row.original.tags) {
          return false;
        }
        return row.original.tags
          ?.map((tagId) => tags?.find((tag) => tag.id === tagId)?.label)
          ?.filter(isNonNullish)
          ?.some((tagLabel) => filteredTagLabels?.includes(tagLabel));
      },
      meta: {
        filter: {
          placeholder: 'All tags',
          options: (Array.isArray(tags) ? [...tags] : ([] as DbTag[]))
            .sort((a, b) => (a.label.trim() > b.label.trim() ? 1 : -1))
            .map((tag) => tag.label)
            .filter((item) => isNonNullish(item) && (item as string)?.trim()),
        },
        headingCellClassName: 'w-44',
        headingLinkClassName: 'pl-0!',
        isStandaloneDataCell: true,
      },
    },
  );
